<mat-tab-group >
    <ng-container *ngFor="let lang of data">
        <mat-tab>
            <ng-template mat-tab-label>
                <div class="lang-tab">
                    <ng-container *ngIf="(responsive.isMobile$ | async) as isMobile; else noMobileTitle">
                        {{ (mapping[lang.lang] | translate) | firstTwoLetters }}
                    </ng-container>
                    <ng-template #noMobileTitle>
                        {{ mapping[lang.lang] | translate }}
                    </ng-template>
                </div>
              </ng-template>
            <mat-form-field>
                <textarea matInput [(ngModel)]="lang.tpl"></textarea>
            </mat-form-field>
        </mat-tab>
    </ng-container>
</mat-tab-group>
